import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Join.css';
import Diamond from '../../icons/diamond-h.png';

const Join = () => {
    const [name, setName]= useState('');
    const [room, setRoom]= useState('');
    return (
        <>
       
        <div className="joinOuterContainer">
            
            <div className="joinInnerContainer">
            <h1 className="name  sm:mt-10 text-2xl md:text-2xl  colorWhite md:leading-10 md:mb-15 md:pb-10" >
                Join communities that share your same interest
                   <center><img src={Diamond} alt="interest" height="20" width="20" /></center> 
                </h1>
                <h1 className="heading" >Join Now!</h1>
                <div > <input  placeholder="Name" className="joinInput" type="text" onChange={(event)=> setName(event.target.value)} />  </div>
                <div > <input placeholder="Room" className="joinInput mt-20" type="text" onChange={(event)=> setRoom(event.target.value)}  /> </div>
                <Link onClick={event => (!name || !room) ? event.preventDefault() : null} to={`/chat?name=${name}&room=${room}`}>
                    <button className="button mt-20" type="submit" > Sign In </button>
                </Link>
            </div>
        </div>
        </>
    )
}

export default Join
